import { render } from "./RegistrationPopup.vue?vue&type=template&id=6c3cf258&scoped=true"
import script from "./RegistrationPopup.vue?vue&type=script&lang=js"
export * from "./RegistrationPopup.vue?vue&type=script&lang=js"

import "./RegistrationPopup.vue?vue&type=style&index=0&id=6c3cf258&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c3cf258"]])

export default __exports__